import React from 'react';

const RightAlignCell = (cell) => {
  cell.style.display = 'block';
  return <div style={{ width: '100%', textAlign: 'right' }}>{cell.cellValue}</div>;
};

export default RightAlignCell;
